const headers = [
    {
        key: 'sector',
        is_self_table: true,
        is_foreign_schema: true,
        is_multiple: false,
        metric_update_options: {
            show: true,
            type: 'select',
            parent_key: null,
        },
    },
    {
        key: 'tsrs_1',
        is_self_table: false,
        is_foreign_schema: false,
        is_multiple: false,
        metric_update_options: {
            show: true,
            type: 'text',
            parent_key: null,
        },
    },
    {
        key: 'tsrs_2',
        is_self_table: false,
        is_foreign_schema: false,
        is_multiple: false,
        metric_update_options: {
            show: true,
            type: 'text',
            parent_key: null,
        },
    },
    {
        key: 'tsrs_volume',
        is_self_table: false,
        is_foreign_schema: false,
        is_multiple: false,
        metric_update_options: {
            show: true,
            type: 'text',
            parent_key: null,
        },
    },
    {
        key: 'gri_requirement',
        is_self_table: false,
        is_foreign_schema: false,
        is_multiple: false,
        metric_update_options: {
            show: true,
            type: 'requirement',
            parent_key: null,
        },
    },
    {
        key: 'tsrs_requirement',
        is_self_table: false,
        is_foreign_schema: false,
        is_multiple: false,
        metric_update_options: {
            show: true,
            type: 'requirement',
            parent_key: null,
        },
    },
    {
        key: 'gri',
        is_self_table: true,
        is_foreign_schema: true,
        is_multiple: false,
        metric_update_options: {
            show: true,
            type: 'select',
            parent_key: null,
        },
    },
    {
        key: 'related_sdgs',
        is_self_table: true,
        is_foreign_schema: true,
        is_multiple: true,
        metric_update_options: {
            show: true,
            type: 'select',
            parent_key: null,
        },
    },
    {
        key: 'category',
        is_self_table: true,
        is_foreign_schema: false,
        is_multiple: false,
        metric_update_options: {
            show: false,
            type: 'select',
            parent_key: null,
        },
    },
    {
        key: 'element',
        is_self_table: true,
        is_foreign_schema: false,
        is_multiple: false,
        metric_update_options: {
            show: false,
            type: 'select',
            parent_key: 'category',
        },
    },
    {
        key: 'kpi',
        is_self_table: true,
        is_foreign_schema: false,
        is_multiple: false,
        metric_update_options: {
            show: true,
            type: 'select',
            parent_key: 'element',
        },
    },
    {
        key: 'name',
        is_self_table: false,
        is_foreign_schema: false,
        is_multiple: false,
        metric_update_options: {
            show: true,
            type: 'text',
            parent_key: null,
        },
    },
    {
        key: 'unit',
        is_self_table: false,
        is_foreign_schema: false,
        is_multiple: false,
        metric_update_options: {
            show: true,
            type: 'text',
            parent_key: null,
        },
    },
    {
        key: 'formula',
        is_self_table: false,
        is_foreign_schema: false,
        is_multiple: false,
        metric_update_options: {
            show: true,
            type: 'text',
            parent_key: null,
        },
    },
    {
        key: 'control',
        is_self_table: false,
        is_foreign_schema: false,
        is_multiple: false,
        metric_update_options: {
            show: true,
            type: 'text',
            parent_key: null,
        },
    },
    {
        key: 'description',
        is_self_table: false,
        is_foreign_schema: false,
        is_multiple: false,
        metric_update_options: {
            show: true,
            type: 'text',
            parent_key: null,
        },
    },
    {
        key: 'objective',
        is_self_table: true,
        is_foreign_schema: false,
        is_multiple: false,
        metric_update_options: {
            show: true,
            type: 'select',
            parent_key: null,
        },
    },
    {
        key: 'related_departments',
        is_self_table: true,
        is_foreign_schema: true,
        is_multiple: true,
        metric_update_options: {
            show: true,
            type: 'select',
            parent_key: null,
        },
    },
];

export default headers;